import {SectionIntro, Section} from '@primer/react-brand'
import type {FeaturedContentProps} from './types'
import {renderWithNoMarks} from '../../../utils'

const FeaturedContent = ({featureHeading, featureLabel, featureDescription, featureLink}: FeaturedContentProps) => {
  return (
    <Section>
      <SectionIntro align="center">
        {featureLabel && <SectionIntro.Label>{featureLabel}</SectionIntro.Label>}
        <SectionIntro.Heading>{renderWithNoMarks(featureHeading)}</SectionIntro.Heading>
        {featureDescription && (
          <SectionIntro.Description>{renderWithNoMarks(featureDescription)}</SectionIntro.Description>
        )}
        {featureLink && <SectionIntro.Link href={featureLink.fields.href}>{featureLink.fields.text}</SectionIntro.Link>}
      </SectionIntro>
    </Section>
  )
}
export {FeaturedContent}
